import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { Item } from '@models/cart.model';
import { AsHttpParams } from '@models/AsHttpParams.model';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  private store_id: any;
  private URL = environment.rootUrl;
  public setCopyLink$ = new EventEmitter<boolean>();
  public productRefresh$ = new EventEmitter<boolean>();
  public productCardRefresh$ = new EventEmitter<Item>();
  private defaultStore = environment.defaultStore;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: string
  ) { }

  public getProduct(productID: string, storeId?: string): Observable<any> {
    try {
      return this.http.get(`${this.URL}/products/${productID}/branch/${storeId ?? this.defaultStore}`);
    } catch (error: any) {
      return error;
    }
  }

  public async getProductDirect(productID: string, storeId?: string): Promise<any> {
    try {
      return this.http.get(`${this.URL}/products/${productID}/branch/${storeId ?? this.defaultStore}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }


  public async getSupermixProducts(comodin: string, storeId: string): Promise<any> {
    try {
      const params: AsHttpParams = {
        comodin
      };
      return this.http.get(`${this.URL}/products/byComodin/${storeId ?? this.defaultStore}`, {
        params
      }).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public getCarousels(): Observable<any> {
    try {
      return this.http.get(`${this.URL}/carrousels`);
    } catch (error: any) {
      return error;
    }
  }

  public getCarouselsById(storeId: string, carouselId: string, page: number, limit: number): Observable<any> {
    try {
      return this.http.get(`${this.URL}/carrousels/${storeId ?? this.defaultStore}/${carouselId}?page=${page}&limit=${limit}`);
    } catch (error: any) {
      return error;
    }
  }

  public getProducts(storeId: string): Observable<any> {
    try {
      return this.http.get(`${this.URL}/ms-products/branch/${storeId ?? this.defaultStore}?ecommerce=true&page=1&limit=15&keyword=`);
    } catch (error: any) {
      return error;
    }
  }

  public searchProducts(searchData: any): Observable<any> {
    try {
      const params: AsHttpParams = {
        page: searchData.page ?? '1',
        limit: searchData.limit ?? '15',
        keyword: searchData.keyword ?? '',
        department: searchData.department ?? '',
        category: searchData.category ?? '',
        subcategory: searchData.subcategory ?? '',
        brand: searchData.brand ?? '',
        promotion: searchData.promotion ?? '',
        min_price: searchData.min_price ?? '',
        max_price: searchData.max_price ?? '',
        order_price: searchData.order_price ?? '',
        order_name: searchData.order_name ?? '',
        characteristics: searchData.characteristics ?? '',
        orden: searchData.order?.orden ?? '',
        ecommerce: 'true'
      };
      return this.http.get(`${this.URL}/ms-products/branch/${searchData.store_id ?? this.defaultStore}`, {
        params: params ? params : {}
      });
    } catch (error: any) {
      return error;
    }
  }

  public searchProductsDirect(params: AsHttpParams): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      this.store_id = JSON.parse(localStorage.getItem('address') || '{}').store ?? this.defaultStore;
    }
    return this.http.get(`${this.URL}/ms-products/branch/${this.store_id}`, { params: params ?? {} });
  }
}
